<template>
	<ValidationObserver v-slot="{ invalid }" ref="form">
		<div class="row" v-if="contactData">
			<div class="col-md-6">
				<div class="form-group">
					<label>First Name</label>
						<b-form-input type="text" v-model="contactData.first_name"  v-on:keyup.enter="saveContactFn" ref="focusThis" lazy-formatter :formatter="Format.titleCase" />
					</div>
				</div>
				<div class="col-md-6">
					<div class="form-group">
						<label>Last Name</label>
							<b-form-input type="text" v-model="contactData.last_name" v-on:keyup.enter="saveContactFn" lazy-formatter :formatter="Format.titleCase"/>
						</div>
					</div>
					<div class="col-md-6">
					  <div class="form-group">
					    <label>Title</label>
					    <b-form-input type="text" v-model="contactData.position" v-on:keyup.enter="saveContactFn" lazy-formatter :formatter="Format.titleCase"/>
					  </div>
					</div>
					<div class="col-md-6">
						<div class="form-group">
							<label>Company</label>
							<b-form-input type="text" v-model="contactData.company_name"  v-on:keyup.enter="saveContactFn"/>
						</div>
					</div>
					<div class="col-md-6">
						<div class="form-group">
							<label>Email</label>
							<b-form-input type="text" v-model="contactData.email_address"  v-on:keyup.enter="saveContactFn"  lazy-formatter :formatter="Format.email"/>
						</div>
					</div>
					<div class="col-md-6">
						<div class="form-group">
							<label>Phone</label>
							<b-form-input type="text" v-model="contactData.phone"  v-on:keyup.enter="saveContactFn"  lazy-formatter :formatter="Format.phone"/>
						</div>
					</div>
					<div class="col-md-6">
						<div class="form-group">
							<label>Mobile</label>
							<b-form-input type="text" v-model="contactData.cell_phone" v-on:keyup.enter="saveContactFn" lazy-formatter :formatter="Format.phone"/>
						</div>
					</div>
					<div class="col-md-6">
						<div class="form-group">
							<label>Fax</label>
							<b-form-input type="text" v-model="contactData.fax_number" v-on:keyup.enter="saveContactFn" lazy-formatter :formatter="Format.phone"/>
						</div>
					</div>
    <div class="col-md-12">
						<div class="form-group">
							<label>Website</label>
							<b-form-input type="text" v-model="contactData.website"  v-on:keyup.enter="saveContactFn" lazy-formatter :formatter="Format.website"/>
						</div>
					</div>
					<div class="col-md-12">
						<div class="form-group">
							<label>Address</label>
							<b-form-input type="text" class="form-control" v-model="contactData.address"></b-form-input>
						</div>
					</div>
					<div class="col-md-6">
						<div class="form-group">
							<label>City</label>
							<b-form-input type="text" v-model="contactData.city"  v-on:keyup.enter="saveContactFn"  lazy-formatter :formatter="Format.city"/>
						</div>
					</div>
					<div class="col-md-6">
						<div class="form-group">
							<label>Country</label>
							<multiselect
							v-model="contactData.country_id"
							:options="allCountries"
							:multiple="false"
							@input="filterState"
							></multiselect>
						</div>
					</div>
					<div class="col-md-6">
						<div class="form-group">
							<label>Province</label>
							<multiselect v-model="contactData.province" :options="filteredStates" :multiple="false"></multiselect>
						</div>
					</div>
					<div class="col-md-6">
						<div class="form-group">
							<label>Postal Code</label>
							<b-form-input type="text" v-model="contactData.postal_code"  v-on:keyup.enter="saveContactFn"  lazy-formatter :formatter="Format.postalCode"/>
						</div>
					</div>
					<div class="col-md-12">
						<div class="form-group">
							<label>Notes</label>
							<b-form-textarea class="form-control" v-model="contactData.notes"></b-form-textarea>
						</div>
					</div>
					<div class="col-md-12">
												<div class="row" v-show="showErrorAlert">
													<div class="col">
						      			<b-alert v-model="showErrorAlert" variant="danger">There is a problem with the information entered above.</b-alert>				</div>
						      		</div>
						<div class="row">
							<div class="col">
								<button class="btn btn-primary" type="button" @click="saveContactFn" data-dismiss="modal">Save</button>
							</div>
							<div class="col text-right">
								<button class="btn btn-text" type="button" @click="removeContactFn" data-dismiss="modal">Remove from call</button>
							</div>
						</div>


					</div>
				</div>
			</ValidationObserver>
		</template>

		<script>
		import { mapGetters, mapState } from "vuex";
		import Format from "../../utility/Format"

		export default {
			data() {
				return {
					filteredStates: [],
					Format,
					showErrorAlert:false,
				};
			},
			props: ["namespace"],
			computed: {
				...mapState({
					state(state) {
						return state[this.namespace]
					},
					allCountries(state, getters) {
						return getters['allCountries']
					},
					allStates(state, getters) {
						return getters['allStates']
					},
					deliverableDetail(state, getters) {
						return getters[this.namespace + 'deliverableDetail']
					},
					deliverableContactsLabel(state, getters) {
						return getters[this.namespace + 'deliverableContactsLabel']
					},
					deliverableContactCompanyLabel(state, getters) {
						return getters[this.namespace + 'deliverableContactCompanyLabel']
					},
					currentFieldKey(state, getters) {
						return getters[this.namespace + 'currentFieldKey']
					},
					currentContactData(state, getters) {
						return getters[this.namespace + 'currentContactData']
					},
					deliverableId(state, getters) {
						return getters[this.namespace + 'deliverableId']
					},
				}),
				contactData() {
					return this.currentContactData;
			// return _.find(this.deliverableDetail.contacts, {
			//   id: this.currentContactId
			// });
		}
	},
	methods: {
		focusMyElement() {
			this.$refs.focusThis.focus()
		},
		saveContactFn() {
			if (this) {
			let that = this;
				this.$refs.form.validate().then(success => {
					if (!success) {
						that.showErrorAlert = true;
						return;
					}
					that.showErrorAlert = false;
					that.$store.dispatch("updateSpokesperson", that.contactData);
					that.$bvModal.hide('editSpokespersonModal')
				});
			}
		},

		removeContactFn() {
			if (this.contactData.id) {
				this.$store.dispatch("removeDeliverableSpokesperson", this.contactData.id);
			}
			this.$bvModal.hide('editSpokespersonModal')
		},
		filterState() {
			let allStatesData = this.allStates,
			usStates = allStatesData.slice(0, 50),
			canadaStates = allStatesData.slice(51);
			this.filteredStates =
			this.contactData.country_id == "Canada" ? canadaStates : usStates;
		}
	},
	created() {
		this.filterState();
	}
};
</script>

<style>
</style>